// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.detail-json[data-v-af4f004e] {\n  max-height: 300px;\n  overflow: auto;\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n.v-btn[data-v-af4f004e] {\n  text-transform: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
